import { id } from 'date-fns/locale';
import React, { useEffect, useState } from 'react';
import { LoadAllTemoignageId } from '../../../actions/Temoignages/TemoignageAction';
import AllRoutes from '../../../nametitle/AllRoutes';
import { Localvalue } from '../../../nametitle/localValue';

const ViewTemoignagePage = () => {
  
  const [coverPicture, setcoverPicture] = useState("https://images.pexels.com/photos/771742/pexels-photo-771742.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1");
  var  idTemoignage =  localStorage.getItem(Localvalue.idTemoignage);
  const [temoinget , settemoiget] =  useState([]);
  useEffect(()=>{
    LoadAllTemoignageId(idTemoignage ,settemoiget )
  console.log(temoinget)
  },[]);



  return (
    <div className="translatable w-full px-4">

      <div className="translatable flex justify-start mt-2">
        <a href={`/${AllRoutes.admin}/${AllRoutes.temoins}`}>
          <button className="translatable btn btn-outline-primary">
            retour
          </button>
        </a>
      </div>

            <div className="translatable  w-full rounded-lg mt-3 shadow-md min-h-[700px] border-t">
            <div className="translatable w-full flex space-x-3 px-4 pt-3">
              <img src={coverPicture} className="translatable h-[50px] w-[50px] rounded-[50%]" />
              <h2 className="translatable text-xl">Nom  autheur {temoinget.title}</h2>
            </div>
            <div className="translatable w-full flex space-x-3 px-4 pt-3">
              <img src={temoinget.coverPicture} className="translatable h-[400px] w-96 " />
              <div className="translatable text-xl" dangerouslySetInnerHTML={{ __html: temoinget.content }} >
                
              </div>
            </div>
    
    
          </div>
         


    </div>
  )
}

export default ViewTemoignagePage;